import { cn } from '@/lib/utils'
import { Calendar, CreditCard } from 'lucide-react'
import type { SettlementInfo } from '@/types/dashboard'

interface SettlementCardProps { settlement: SettlementInfo; className?: string }

export function SettlementCard({ settlement, className }: SettlementCardProps) {
  return (
    <div className={cn('rounded-xl border border-border bg-card p-5', className)}>
      <h3 className="text-sm font-medium text-muted-foreground mb-4">Settlement</h3>
      <div className="space-y-3">
        <div className="flex items-center gap-3">
          <Calendar className="h-4 w-4 text-muted-foreground" />
          <div>
            <p className="text-xs text-muted-foreground">Next Settlement</p>
            <p className="text-sm font-medium text-foreground">{settlement.next_date}</p>
          </div>
        </div>
        <div className="flex items-center gap-3">
          <CreditCard className="h-4 w-4 text-muted-foreground" />
          <div>
            <p className="text-xs text-muted-foreground">Estimated Amount</p>
            <p className="text-sm font-medium text-foreground">
              {settlement.currency === 'KRW' ? '₩' : '$'}{settlement.amount.toLocaleString()}
            </p>
          </div>
        </div>
        <p className="text-xs text-muted-foreground">Stripe Connect: ****{settlement.stripe_account}</p>
      </div>
    </div>
  )
}
